import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Target, Zap, Shield, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import PageLayout from "@/components/PageLayout";

const values = [
  { icon: Target, key: "mission" },
  { icon: Zap, key: "innovation" },
  { icon: Shield, key: "privacy" },
  { icon: Heart, key: "ux" },
];

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <SEO
        title={t("about.title")}
        description={t("about.meta")}
        canonical="/about"
      />
      <section className="section-y-sm px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="animate-in-up font-heading text-fluid-h1 font-bold text-white mb-4">
              {t("about.title")}
            </h1>
            <p
              className="animate-in-up text-fluid-lead text-slate-400 max-w-2xl mx-auto"
              style={{ "--d": "100ms" }}
            >
              {t("about.subtitle")}
            </p>
          </div>

          <div className="glass rounded-3xl p-8 mb-12">
            <h2 className="font-heading text-2xl font-bold text-white mb-4">
              {t("about.storyTitle")}
            </h2>
            <p className="text-slate-400 leading-relaxed mb-4">
              {t("about.story1")}
            </p>
            <p className="text-slate-400 leading-relaxed">
              {t("about.story2")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {values.map(({ icon: Icon, key }) => (
              <div
                key={key}
                className="glass lift rounded-2xl p-6 hover:border-primary/40 group"
              >
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/25 to-accent/15 border border-white/10 flex items-center justify-center mb-3 group-hover:scale-105 transition-transform">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <h3 className="font-semibold text-white mb-2">
                  {t(`about.values.${key}.title`)}
                </h3>
                <p className="text-slate-400 text-sm">
                  {t(`about.values.${key}.desc`)}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link to="/register">
              <Button
                size="lg"
                className="btn-glow bg-primary-strong hover:bg-primary-strong/90 text-lg px-8"
              >
                {t("landing.cta")} <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};
export default AboutPage;
